import React, { useState } from "react";
import styles from "./Submission.module.scss";
import IconButton from "../../../../components/ButtonIcon/ButtonIcon";
import anet_logo from "../../../../../../images/v2/anet-logo.png";
import ChevronRight16 from "../../../../assets/svg/icons/common/ChevronRight16";
import AnetApprovalModal from "./AnetApprovalModal";
import AnetStatusModal from "./AnetStatusModal";
import toast from "react-hot-toast";
import moment from "moment";
import { getAnetStatusColor as getStatusColor } from "../../../../utils/anet-status-colors";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import useUserStore from "../../../../stores/user";

const APPROVABLE_STATUSES = ["New", "InProgress", "Underwriting"];
const TERMINAL_STATUSES = ["Declined", "Cancelled", "Fraud"];

function AnetItem({ appData, onSuccess }) {
  const [expanded, setExpanded] = useState(false);
  const [openApprovalModal, setOpenApprovalModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const isEntitySuperAdmin = useUserStore((state) => state.isEntitySuperAdmin);

  const anetData = appData.anet_application;
  const processorConfig = appData.anet_processor_config;

  const handleSuccess = () => {
    onSuccess && onSuccess();
    toast.success("Action completed successfully");
  };

  if (!anetData) {
    return null;
  }

  const isApproved = anetData.anet_status === "Approved";
  const canApprove = isEntitySuperAdmin && APPROVABLE_STATUSES.includes(anetData.anet_status);
  const canDecline =
    isEntitySuperAdmin && !isApproved && !TERMINAL_STATUSES.includes(anetData.anet_status);

  return (
    <>
      <div className={styles.submission_item}>
        <div className={styles.item_head}>
          <input type="checkbox" />
          <IconButton onClick={() => setExpanded(!expanded)}>
            <ChevronRight16 />
          </IconButton>
        </div>

        <div className={styles.body}>
          <div className={styles.processor}>
            <img src={anet_logo} alt="ANET" />
            <h6>Authorize.Net</h6>
          </div>

          <div className={`${styles.action} ${styles.anet_action_row}`}>
            {canApprove && (
              <IconButton
                bgColor={"#4C70EF"}
                textColor="#FFF"
                onClick={() => setOpenApprovalModal(true)}
              >
                Approve
              </IconButton>
            )}

            {canDecline && (
              <IconButton
                bgColor={"#EDEDF4"}
                textColor="#050506"
                onClick={() => setOpenStatusModal(true)}
              >
                Decline
              </IconButton>
            )}
          </div>
        </div>
      </div>

      <div
        className={`${styles.submission_data} ${expanded ? styles.expanded : ""}`}
      >
        {expanded && (
          <>
            <div className={styles.statuses}>
              <div className={styles.status_item}>
                <span className={styles.name}>Status</span>
                <div className={styles.status_color}>
                  <StatusDot color={getStatusColor(anetData.anet_status)} />
                  <span>{anetData.anet_status}</span>
                </div>
              </div>

              {anetData.anet_app_submission_date && (
                <div className={styles.status_item}>
                  <span className={styles.name}>Submitted</span>
                  <div className={styles.status_color}>
                    <span>
                      {moment(anetData.anet_app_submission_date).format(
                        "MMM D, YYYY | H:mm A"
                      )}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {processorConfig && (
              <div className={styles.statuses}>
                <div className={styles.status_item}>
                  <span className={styles.name}>Processor</span>
                  <div className={styles.status_color}>
                    <span>{processorConfig.processor_name}</span>
                  </div>
                </div>

                <div className={styles.status_item}>
                  <span className={styles.name}>MCC</span>
                  <div className={styles.status_color}>
                    <span>{processorConfig.mcc}</span>
                  </div>
                </div>

                {processorConfig.payment_types && (
                  <div className={styles.status_item}>
                    <span className={styles.name}>Payment Types</span>
                    <div className={styles.status_color}>
                      <span>{processorConfig.payment_types.join(", ")}</span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>

      <AnetApprovalModal
        isOpen={openApprovalModal}
        onClose={() => setOpenApprovalModal(false)}
        appData={appData}
        anetData={anetData}
        onSuccess={handleSuccess}
      />

      <AnetStatusModal
        isOpen={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        appData={appData}
        anetData={anetData}
        onSuccess={handleSuccess}
      />
    </>
  );
}

export default AnetItem;
